import * as React from 'react'

import {
  ProductReviewsContainer,
  ProductReviewsWithMediaFilterContainer,
} from '../../../../../containers/ProductReviewsContainer'
import { ReviewsProductGroupDataProvider } from '../../../../../containers/ReviewsProductGroupDataService/useReviewsProductGroupData'

import { Template } from './Template'
import { useViewModel } from './useViewModel'

const ReviewsPageViewWithoutProviders: React.FC<{
  handle: string
  writeReview: boolean
}> = ({ handle, writeReview }) => {
  const viewModel = useViewModel({ writeReview })

  return <Template handle={handle} {...viewModel} />
}

export const ReviewsPageView: React.FC<{
  handle: string
  colorKey: string | undefined | null
  writeReview: boolean
}> = ({ handle, writeReview, colorKey }) => {
  return (
    <ReviewsProductGroupDataProvider handle={handle} colorKey={colorKey}>
      <ProductReviewsContainer.Provider>
        <ProductReviewsWithMediaFilterContainer.Provider>
          <ReviewsPageViewWithoutProviders handle={handle} writeReview={writeReview} />
        </ProductReviewsWithMediaFilterContainer.Provider>
      </ProductReviewsContainer.Provider>
    </ReviewsProductGroupDataProvider>
  )
}
